import * as RT from './routeType'

// RUTAS PAGINAS ARBOLEC //
export const MAIN = '/'
export const TREE = `${MAIN}${RT.TREE}`
export const MANAGEMENT = `${MAIN}${RT.MANAGEMENT_TREE}`
export const REPORT = `${MAIN}${RT.GENERATE_REPORT}`
export const REGISTER_TREE = `${MAIN}${RT.REGISTER_TREE}`
export const AUTHENTICATION_ROUTE = `${MAIN}${RT.AUTHENTICATION}`
export const ADMINISTRATION_ROUTE = `${MAIN}${RT.ADMINISTRATION}`
export const TERRITORIAL_MANAGEMENT_ROUTE = `${MAIN}${RT.TERRITORIAL_MANAGEMENT}`

export const ADMINISTRATION_DEFAULT_TAB = RT.ADMINISTRATION_TAB_FAMILIES
export const TERRITORIAL_MANAGEMENT_DEFAULT_TAB = RT.TERRITORIAL_TAB_COUNTRY

export const ADMINISTRATION_DEFAULT_ROUTE = `${ADMINISTRATION_ROUTE}/${ADMINISTRATION_DEFAULT_TAB}`
export const TERRITORIAL_MANAGEMENT_DEFAULT_ROUTE = `${TERRITORIAL_MANAGEMENT_ROUTE}/${TERRITORIAL_MANAGEMENT_DEFAULT_TAB}`

// RUTAS COMPLETAS DESDE RAIZ
export const REPORT_ROUTE = `${ADMINISTRATION_ROUTE}${REPORT}`
export const LOGIN_ROUTE = `${MAIN}${RT.AUTHENTICATION}/${RT.AUTH}`
export const FORGOT_PASSWORD_ROUTE = `${MAIN}${RT.AUTHENTICATION}/${RT.FORGOT_PASSWORD}`
export const PROFILE_ROUTE = `${MAIN}${RT.PROFILE}`
export const REGISTER_USER_ROUTE = `${MAIN}${RT.AUTHENTICATION}/${RT.REGISTER_USER}`
